import React from 'react';
import { FaPlus } from 'react-icons/fa';
import '../styles/Partners.css';

const AdminPartners = () => {
  const partners = ['Kenya Power','SolarTech Solutions','BuildRight Construction','SecureNet Systems','Green Energy Africa','TechPro Electric','SafeGuard Alarms','PowerBox Distributors'];
  return (
    <div className="partners-page">
      <h1>Partners</h1>
      <p>Manage your business partners.</p>
      <button className="add-btn"><FaPlus /> Add Partner</button>
      <table className="partners-table">
        <thead><tr><th>#</th><th>Partner</th><th>Area</th><th>Status</th><th>Actions</th></tr></thead>
        <tbody>{partners.map((p,i)=>(<tr key={i}><td>{i+1}</td><td>{p}</td><td>Energy</td><td>Active</td><td><button className="edit-btn">Edit</button> <button className="delete-btn">Delete</button></td></tr>))}</tbody>
      </table>
    </div>
  );
};
export default AdminPartners;
